class AppNavigation extends Component {
	constructor(el) {
		super(el);
		this.closer = this.$find('[data-closer]');

		this.navTop = document.querySelector('[data-navigation-top]');
		this.navMain = document.querySelector('[data-navigation-main]');
		this.movedNodes = [];
		this.isMoved = false;

		this.addEventListeners();
		this.handleResponsiveNav();
	}

	openNav() {
		this.$el.classList.add('is-opened');
	}

	closeNav() {
		this.$el.classList.remove('is-opened');
	}

	toggleSubNav(opener) {
		opener.classList.toggle('is-opened');
		if (opener.nextElementSibling) {
			opener.nextElementSibling.classList.toggle('is-opened');
		}
	}

	closeSubNav() {
		const openers = document.querySelectorAll('[data-opener]');
		openers.forEach(opener => {
			opener.classList.remove('is-opened');
			if (opener.nextElementSibling) {
				opener.nextElementSibling.classList.remove('is-opened');
			}
		});
	}

	handleResponsiveNav() {
		if (!this.navTop || !this.navMain) return;

		const isMobileView = window.innerWidth < 1200;

		if (isMobileView && !this.isMoved) {
			this.movedNodes = Array.from(this.navTop.childNodes);
			this.movedNodes.forEach(node => this.navMain.appendChild(node));
			this.isMoved = true;
		} else if (!isMobileView && this.isMoved) {
			this.movedNodes.forEach(node => this.navTop.appendChild(node));
			this.isMoved = false;
			this.movedNodes = [];
		}
	}

	addEventListeners() {
		if (this.closer) {
			this.closer.addEventListener('click', () => {
				this.closeNav();
				this.closeSubNav();
			});
		}

		document.addEventListener('click', (event) => {
			const opener = event.target.closest('[data-opener]');
			if (opener) {
				this.toggleSubNav(opener);
			}
		});

		EventBus.getInstance().addEventListener('mainNavigationOpen', () => this.openNav());

		window.addEventListener('scroll', () => {
			if (this.$el.classList.contains('is-opened')) {
				this.closeNav();
				this.closeSubNav();
			}
		});

		document.addEventListener('click', (event) => {
			if (this.$el.classList.contains('is-opened') && !this.$el.contains(event.target)) {
				const isOpener = event.target.closest('[data-opener]');
				if (!isOpener) {
					this.closeNav();
					this.closeSubNav();
				}
			}
		});

		window.addEventListener('resize', () => {
			this.handleResponsiveNav();
		});
	}
}
